import settings from '../utils/settings';

const environment = settings.subDomain;
const environmentWithQA = settings.subDomainWithQA;
const semContent = `https://sem-content${environmentWithQA}.healthcare.com`;
const plans = `https://plans-srv${environment}.healthcare.com`;
const cdn = 'https://cdn.healthcare.com/';
const pivotBackEnd = `https://backend${environmentWithQA}.pivothealth.com`;
const enrollDomain = `https://enroll${environmentWithQA}.pivothealth.com`;

/**
 * Services:
 *
 * @see https://github.com/healthcarecom/sem-content#company-logos-and-plans-per-state
 */

/**
 * Set HC Core configuration agnostic to the environment
 * or generated dynamically based on environemnt.
 */
export default {
  geoIp: 'https://geoip.pivothealth.com/', // POST
  companyLogos: `${semContent}/company/logos/:siteName/:stateAcronym`, // GET
  companyPlansLogos: `${semContent}/company/logos/plans/:siteName/:stateAcronym`, // GET
  // endpoint was expecting a header {'Content-Type': 'application/json'}
  verifyEmail: `${semContent}/verifymail/:email/:src/:healthcareSession.json`, // GET
  pageViewEvent: `${semContent}/pageview/pageviewevent`, // POST
  brandedCalls: `${semContent}/calls/advertiser`, // POST
  cdn, // GET
  geoLocation: `https://geolocation${environment}.healthcare.com/`,
  invocaPhoneV3: `${semContent}/v3/phone/`, // POST
  invocaPhoneV4: `${semContent}/v4/phone/`, // POST
  callManagement: `${semContent}/call/campaign`, // POST
  campaignscallManagement: `${semContent}/call/campaigns/`, // POST
  getFPL: `${plans}/GetFPL`,
  invalidPhones: `${cdn}resources/lead-form/invalid-phone.json`,
  pivotBackEnd,
  enrollDomain,
};
